import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeMode } from "../ErpScope";

interface LockViewPageProps extends NSARouterMakerResult, ErpRouterProps { }

export default class LockViewPage extends Component<LockViewPageProps>
{
    override render()
    {
        return (
            <ErpLayout {...this.props} mode={ErpScopeMode.None} pages={{ entity: ErpEntities.lock(this.props), view: {} }}><></></ErpLayout>
        );
    }
}